// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bUlX","colMin":"styles_colMin__2j4ki"};